import { SignupComponent } from './signup/signup.component';

export const CONTAINERS = [SignupComponent];

export * from './signup/signup.component';
